import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import querystring from 'vux/src/tools/querystring/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

Vue.use(WechatPlugin)



let AjaxUrl = 'http://www.kmjiu.com/public/index.php/app/';


let documentUrl = document.URL;
documentUrl = documentUrl.substr(documentUrl.indexOf('?') + 1);
const wxConfig = {
appId: 'wxd907496c121b0546',
appsecret: '0dd66071e0cf0160ce7c2c9c328cac40',
redirect_uri: encodeURIComponent(document.URL),
wxCode: querystring.parse(documentUrl).code
};


var securitytoken;
const uuid = 'wsa';
let shop_id = '336';
export const ver = '1.2.1';
if (documentUrl.indexOf('shop_id') > -1) {
let str = documentUrl.substr(documentUrl.indexOf('shop_id'));
let shop_id = str.replace(/[^0-9]/ig, "");
shop_id = shop_id
};



axios.defaults.baseURL = AjaxUrl;
Vue.prototype.$http = axios;


axios.interceptors.response.use(function(response) {
store.commit('hideIsLoading');










return response;
}, function(error) {
store.commit('hideIsLoading');

return Promise.reject(error);
});

axios.interceptors.request.use(function(config) {


return config;
}, function(error) {

return Promise.reject(error);
});


const ua = navigator.userAgent.toLowerCase();
const isWeixin = ua.indexOf('micromessenger') != -1;


const Ajax = {
get: function(url, fn) {
var obj = new XMLHttpRequest(); 
obj.open('GET', AjaxUrl + url, false);
obj.onreadystatechange = function() {
if (obj.readyState == 4 && obj.status == 200 || obj.status == 304) { // readyState==4说明请求已完成
fn.call(this, JSON.parse(obj.responseText)); 
}
};
obj.send(null);
},
post: function(url, data, fn) {
var obj = new XMLHttpRequest();
obj.open("POST", url, true);
obj.setRequestHeader("Content-type", "application/x-www-form-urlencoded"); 
obj.onreadystatechange = function() {
if (obj.readyState == 4 && (obj.status == 200 || obj.status == 304)) { // 304未修改
fn.call(this, JSON.parse(obj.responseText));
}
};
obj.send(data);
}
};



export const getCartCount = params => {
axios.get(`/cart/getCartCount.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}`).then(res => {
store.commit('updateCartCount', res.data.count);
});
};


export const wxConfigAjax = params => {

function config() {
axios.get(`http://www.kmjiu.com/public/activities/wechat_config.html?url=${encodeURIComponent(document.URL)}`).then(res => {
var wechatConfig = res.data;
wechatConfig.jsApiList.push('scanQRCode');
Vue.wechat.config({
debug: wechatConfig.debug,
appId: wechatConfig.appId,
timestamp: wechatConfig.timestamp,
nonceStr: wechatConfig.nonceStr,
signature: wechatConfig.signature,
jsApiList: wechatConfig.jsApiList
});
});
};

config();


Vue.wechat.ready((res) => {
Vue.wechat.onMenuShareAppMessage({
title: params.title,
desc: params.desc,
link: 'http://www.kmjiu.com/b2c_vue/#/' + params.url,
imgUrl: params.imgUrl ? params.imgUrl : 'http://www.kmjiu.com/public/statics/images/216.png',
success: function() {

params.fn && params.fn();
},
cancel: function() {

}
});

Vue.wechat.onMenuShareTimeline({
title: params.title ? params.title : "快买酒商城",
link: 'http://www.kmjiu.com/b2c_vue/#/' + params.url,
imgUrl: params.imgUrl ? params.imgUrl : store.state.shopInfo.shop_logo,
success: function() {
params.fn && params.fn();
},
cancel: function() {

}
});
});

Vue.wechat.error(res => {

});
};


export const getDetail = params => {
return axios.get(`/item/item.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&device=ios&version=1.2.0&shop_id=${shop_id}&` + params);
};


export const getItemDetail = params => {
return axios.get(`http://www.kmjiu.com/public/index.php/wap/itempic.html?uuid=${uuid}&shop_id=${shop_id}&&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&notopbar=1&` + params);
};


export const addCollect = params => {
return axios.get(`/item/fav.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const cancalCollect = params => {
return axios.get(`/item/delFav.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const getShopCat = params => {
return axios.get(`/cate/getShopCat.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&`);
};


export const search = params => {
return axios.get(`/item/search.html?operationtype=replace&uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const addCart = params => {
return axios.get(`/cart/addCart.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const createOrder = params => {
return axios.get(`/trade/create.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const shopCartCreateOrder = params => {
return axios.get(`/trade/cart_create.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const createPay = params => {
return axios.get(`/pay/create.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&` + params);
};


export const getAddrList = params => {
return axios.get(`/addr/getAddrList.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}`);
};


export const saveAddr = params => {
return axios.get(`/addr/saveAddr.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const getIndex = params => {
return axios.get(`/shopcenter/index_new.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const shopCartCheck = params => {
return axios.get(`/cart/check_out.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const detailCheck = params => {
return axios.get(`/cart/cart-total.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&` + params).catch(res => {
alert('请刷新重试')
});
};


export const setDefAddr = params => {
return axios.get(`/addr/setDefAddr.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const getDefAddr = params => {
return axios.get(`/addr/getDefAddr.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const delAddr = params => {
return axios.get(`/addr/delAddr.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const cartUpdate = params => {
return axios.get(`/cart/cart-update.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}` + params);
};


export const removeCart = params => {
return axios.get(`/cart/removeCart.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const getCartInfo = params => {
return axios.get(`/cart/getCartInfo.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&` + params);
};


/*
nuconfirm 待收货
unrate 未评价订单数
*/
export const getUCTN = params => {
axios.get(`/user/getUCTN.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params).then(res => {
if (res.data.error) {

console.error(res);
return;
};
store.commit('updateOrderNum', res.data.TradeNum);
});
};


export const getTrades = params => {
return axios.get(`/user/getTrades.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
};


export const confirmReceipt = params => {
return axios.get(`/trade/confirmReceipt.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const closeTrade = params => {
return axios.get(`/trade/closeTrade.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const confirmCloseTrade = params => {
return axios.get(`/trade/confirmCloseTrade.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const selectLogistics = params => {
return axios.get(`/trade/selectLogistics.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getTradeInfo = params => {
return axios.get(`/trade/getTradeInfo.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const coinExchange = params => {
return axios.get(`/user/coinExchange.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const couponList = params => {
return axios.get(`/coupon/couponList.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const system = params => {
if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
return 'ios';
} else if (/(Android)/i.test(navigator.userAgent)) {
return 'Android';
};
};


function collectShop() {
return axios.get(`/user/collectShop.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}`);
}


export const getFavList = params => {
return axios.get(`/user/getFav.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getShopFavList = params => {
return axios.get(`/user/getShopFav.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getCollectAll = params => {
return axios.all([getFavList(), getShopFavList()]);
}


export const removeByValue = (arr, val) => {
for (var i = 0; i < arr.length; i++) {
if (arr[i] == val) {
arr.splice(i, 1);
break;
}
}
};


export const getActInfo = params => {
return axios.get(`/activityclass/getActInfo.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getGroupList = params => {
return axios.get(`/groupbuy/getList.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getShopAllCoupon = params => {
return axios.get(`/coupon/shopAllCoupon.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getRobsList = params => {
return axios.get(`/rob/getRobsList.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getSignIn = params => {
return axios.get(`/user/sign.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const dosign = params => {
return axios.get(`/user/dosign.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getRank = params => {
return axios.get(`/rob/getRank.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getRobLogs = params => {
return axios.get(`/rob/getRobLogs.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getFinalNumber = params => {
return axios.get(`/rob/getFinalNumber.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getRobInfo = params => {
return axios.get(`/rob/getRobInfo.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const createNumbers = params => {
return axios.get(`/rob/createNumbers.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getShopKeyWord = params => {
return axios.get(`/item/getShopKeyWord.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const groupbuy = params => {
return axios.get(`/groupbuy/myList.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const groupGetInfo = params => {
return axios.get(`/groupbuy/getInfo.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getGroupTradeInfo = params => {
return axios.get(`/trade/getTradeInfo.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const myNumbers = params => {
return axios.get(`/rob/myNumbers.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const shopAllCoupon = params => {
return axios.get(`/coupon/shopAllCoupon.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getCoupon = params => {
return axios.get(`/coupon/getCoupon.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const login = params => {
return axios.get(`/passport/login.html?uuid=${uuid}&device=android&version=1.1.0_10&shop_id=${shop_id}&` + params);
}


export const getUserInfoByToken = params => {
return axios.get(`/user/getUserInfoByToken.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const updatePwd = params => {
return axios.get(`/passport/updatePwd.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getFinalNumberInfo = params => {
return axios.get(`/rob/getFinalNumberInfo.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getMyFinalNumberList = params => {
return axios.get(`/rob/getMyFinalNumberList.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const getorderList = params => {
return axios.get(`/rob/getorderList.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const winningConfirm = params => {
return axios.get(`/rob/confirm.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&` + params);
}


export const aftersalesApply = (tid, oid) => {
return axios.get(`/aftersales/aftersalesApply.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&tid=${tid}&oid=${oid}`);
}


export const commitAftersalesApply = params => {
return axios.get(`/aftersales/commitAftersalesApply.html?uuid=${uuid}&device=android&version=1.1.0_10&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&tid=${params.tid}&oid=${params.oid}&reason=${params.text}
`);
}


export const aftersalesExchange = params => {
return axios.get(`/aftersales/aftersalesExchange.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${shop_id}&id=${params}`);
}


export const changeShop = params => {
return axios.get(`/user/changeShop.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&shop_id=${params}`);
}


function shopIdDefault(cd) {

if (documentUrl.indexOf('shop_id') == -1) {
collectShop();
Ajax.get(`shop/default.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}`, res => {
cd(res.data.shop_id);
});
}
}

/*
爱奇艺 8年之谢 宣传页接口
获取兑换码
*/
export const iqiyi_code = params => {
return axios.get(`/activity/iqiyi_code.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&code=${params}`);
}


export const iqiyi_get = params => {
return axios.get(`/activity/iqiyi_get.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&type=${params}`);
}


export const qingda_code = params => {
return axios.get(`/activity/iqiyi_code.html?uuid=${uuid}&securitytoken=${store.state.loginInfo.securitytoken?store.state.loginInfo.securitytoken:securitytoken}&code=${params}&type=qd`);
}



// WEBPACK FOOTER //
// ./src/api/index.js